module.exports = __webpack_public_path__ + "static/media/icon-arrow-up.a7f5e969.svg";